import { usePageLocation } from '../../../features/page';
import { useCurrentOrgOrNull } from './useCurrentOrgOrNull';

export const useCurrentOrg = () => {
  const orgOrNull = useCurrentOrgOrNull();
  const location = usePageLocation();

  if (!orgOrNull) {
    throw new Error(`Can't extract org details from ${location.pathname}`);
  }

  return orgOrNull;
};
